import { toast, ToastContainer } from 'react-toastify';
import axios from 'axios';
import * as THREE from "three";

import React, { useEffect, useState, useCallback } from 'react';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import { FormControl, FormLabel, FormControlLabel, FormGroup, RadioGroup, Button, Checkbox } from '@material-ui/core';
import SideStyle from '../style/sideStyle';
import { GreyRadio } from '../style/customUI';
import { AddIcon } from '../formAk/formUtil';
import { loadSTLFile, loadPLYFile } from '../fileIO/fileLoader';
import { STLExporter } from 'three/addons/exporters/STLExporter.js';

import Param from '../store/param';
import Control from '../store/control';


function save( blob, filename ) {
  const link = document.createElement( 'a' );
  link.style.display = 'none';
  document.body.appendChild( link );
  
  link.href = URL.createObjectURL( blob );
  link.download = filename;
  link.click();
}

function saveArrayBuffer( buffer, filename ) {
  save( new Blob( [ buffer ], { type: 'application/octet-stream' } ), filename );
}

const handleExport = (outputGeom) => {
  console.log(outputGeom)
  if (outputGeom == null) {
    toast.error('No mesh to export.')
    return;
  }

  // if ( showMirror == 1 ) {
  //   var mS = (new THREE.Matrix4()).identity();
  //   //set -1 to the corresponding axis
  //   mS.elements[0] = -1;
  //   mS.elements[10] = -1;
  //   outputGeom.applyMatrix4(mS);
  // }

  const scene = new THREE.Scene();
  const saveGeom = outputGeom.clone();
  const material = new THREE.MeshStandardMaterial( { color: 0x000000 } );
  saveGeom.rotateX(Math.PI/2);
  let mesh = new THREE.Mesh(saveGeom, material);

  scene.add(mesh.clone());

  const exporter = new STLExporter();
  const result = exporter.parse( scene, { binary: true } );

  saveArrayBuffer( result, 'socket.stl' );
}



const FormAlignFinalDeviceFinalStep = () => {
  const style                 = SideStyle();
  const param                 = Param.Get('setup');
  const setParam              = Param.Get('setParam');
  const finalDeviceFinalStep  = Param.Get('finalDeviceFinalStep')
  const setControl            = Control.Get('setControl');
  const standardGeometry      = Control.Get('standardGeometry');

  useEffect(() => {
    setParam(s => {s.activestep = 0})
    // 全てのパラメータをghni最初に全部送って初期化
    var obj = {}
    obj['f00'] = {}

    Object.keys(param).forEach(function (key) {
      obj['f00'][key] = param[key]
    });
  }, []);

  const handleValueScanSocket = (e) => {
    loadSTLFile( e.target.files[0], (mesh) => {
      setControl(s => {s.meshSocketLoad = mesh, s.redrawBox += 1}); // s.type = 'TestSocket',
    });
    setControl(s => {s.showSocket = true})
  }

  /**
   * Handles the change event for the input fields.
   * @param {Event} e - The change event object.
   */
  const onChange = (e) => {
    setParam(s => {s.finalDeviceFinalStep[e.target.name] = Number(e.target.value)});

    console.log(e.target.name, e.target.value)
  };

  /**
   * Handles the change event of checkboxes.
   * @param {Event} e - The change event object.
   */
  const onChangeCheckboxs = (e) => {
    setParam(s => {s.finalDeviceFinalStep[e.target.name] = Number(e.target.checked)});
  }

  // temporal implementation. need to be refactored
  const handleValueGeometry = (e) => {
    setParam(s => {s.finalDeviceFinalStep[e.target.name] = Number(e.target.value)});

    const url = process.env.REACT_APP_RHINO_COMPUTE + '/bk_final_device_local';
    const data = {
      rotation_center_from_the_end_of_socket: finalDeviceFinalStep.rotation_center_from_the_end_of_socket,
      flexion_extension: finalDeviceFinalStep.flexion_extension,
      adduction_abduction: finalDeviceFinalStep.adduction_abduction,
      toeout_toein: finalDeviceFinalStep.toeout_toein,
      trans_x: finalDeviceFinalStep.trans_x,
      trans_y: finalDeviceFinalStep.trans_y,
      max_height_4hole: finalDeviceFinalStep.max_height_4hole,
      cull_index_of_4hole: finalDeviceFinalStep.cull_index_of_4hole,
      bending_holes: finalDeviceFinalStep.bending_holes,
      hexagon0: finalDeviceFinalStep.hexagon0,
      hexagon1: finalDeviceFinalStep.hexagon1,
      hexagon2: finalDeviceFinalStep.hexagon2,
      hexagon3: finalDeviceFinalStep.hexagon3,
      center_hole_disable: finalDeviceFinalStep.center_hole_disable,
      outer_ring_hole: finalDeviceFinalStep.outer_ring_hole,
    };

    console.log(e.target.name, e.target.value)
    data[e.target.name] = Number(e.target.value); // update

    console.log(data)

    const header = {
      headers: {
        'Content-Type': 'application/json',
        //'Content-Type': "text/plain",
        //'Access-Control-Allow-Origin': '*',
      }
    };
    
    const loadingToastId = toast.info("Calculating...", { autoClose: false }); // Show loading toast without auto close

    axios.post(
      url,
      data,
      header,
      //{crossDomain: true},
      //{mode: 'cors'}
      )
    .then(res => {
      console.log(res)
      toast.dismiss(loadingToastId); // Dismiss the loading toast
      toast.success("Success"); // Show success toast

      let tempVertices = res.data.obj.vertices;
      // rotate 90 degs around x axis due to different coordinate system
      tempVertices = tempVertices.map(vertex => [vertex[0], vertex[2], -vertex[1]]);
      // rotate 180 degs around y axis due to different coordinate system

      const tempFaces = res.data.obj.faces;

      // convert array to float32array for three.js buffergeometry
      const vertices = new Float32Array(tempVertices.flat());
      // convert array to uint16array for three.js buffergeometry
      const faces = new Uint32Array(tempFaces.flat());

      const geometry = new THREE.BufferGeometry();
      geometry.setAttribute('position', new THREE.BufferAttribute(vertices, 3));
      geometry.setIndex(new THREE.BufferAttribute(faces, 1));
      //geometry.setIndex(faces)
      geometry.computeVertexNormals();

      console.log(geometry)

      setControl(s => { s.standardGeometry = geometry });
    })
    .catch(err => {
      console.log('error:', err);
      toast.dismiss(loadingToastId); // Dismiss the loading toast
      toast.error("Error!"); // Show error toast
    });
  };

  return (
    <div className={style.outside}>
      <Grid container direction='row' justifyContent='center' alignItems='center' xs={12} spacing={1}>
        <Grid item xs={5}>
          <Button
            component="label"
            className={style.button}
          >
            <input
              id='file'
              accept={[".stl"]}
              type="file"
              name='pathSocket'
              onChange={(e) => handleValueScanSocket(e)}
            />
          </Button>
        </Grid>
      </Grid>

      <Grid container direction='column' justifyContent ='flex-start' alignItems='center'>
        <Grid item xs={12} className={style.subcategory}>Alignment</Grid>
      </Grid>

      <Grid container spacing={1} alignItems='center' justifyContent='center'>
        <TextField
          id='filled-number'
          name='rotation_center_from_the_end_of_socket'
          label='Rotation center(from the end of socket)'
          type='number'
          defaultValue={finalDeviceFinalStep.rotation_center_from_the_end_of_socket}
          fullWidth
          onBlur={onChange}
          InputProps={{
            endAdornment:
              <AddIcon 
                unit='mm' 
                helptext={''}
                title=''
                imgSrc=''
              />,
          }}
          InputLabelProps={{
            style: { color: '#fff' },
            shrink: true,
          }}
          variant='standard'
          inputProps={{
            style: {
              color: 'white',
              textAlign: 'left'
            }, 
            min:0, 
            max:500,
            step:0.1
          }}
        />
      </Grid>

      <Grid container spacing={1} alignItems='center' justifyContent='center'>
        <TextField
          id='filled-number'
          name='flexion_extension'
          label='+Flexion/-Extension'
          type='number'
          defaultValue={finalDeviceFinalStep.flexion_extension}
          fullWidth
          onBlur={onChange}
          InputProps={{
            endAdornment:
              <AddIcon 
                unit='degree' 
                helptext={''}
                title=''
                imgSrc=''
              />,
          }}
          InputLabelProps={{
            style: { color: '#fff' },
            shrink: true,
          }}
          variant='standard'
          inputProps={{
            style: {
              color: 'white',
              textAlign: 'left'
            }, 
            min:-90, 
            max:90,
            step:0.1
          }}
        />
      </Grid>

      <Grid container spacing={1} alignItems='center' justifyContent='center'>
        <TextField
          id='filled-number'
          name='adduction_abduction'
          label='+Adduction/-Abduction'
          type='number'
          defaultValue={finalDeviceFinalStep.adduction_abduction}
          fullWidth
          onBlur={onChange}
          InputProps={{
            endAdornment:
              <AddIcon 
                unit='degree' 
                helptext={''}
                title=''
                imgSrc=''
              />,
          }}
          InputLabelProps={{
            style: { color: '#fff' },
            shrink: true,
          }}
          variant='standard'
          inputProps={{
            style: {
              color: 'white',
              textAlign: 'left'
            }, 
            min:-90, 
            max:90,
            step:0.1
          }}
        />
      </Grid>

      <Grid container spacing={1} alignItems='center' justifyContent='center'>
        <TextField
          id='filled-number'
          name='toeout_toein'
          label='+Toe out/-Toe in'
          type='number'
          defaultValue={finalDeviceFinalStep.toeout_toein}
          fullWidth
          onBlur={onChange}
          InputProps={{
            endAdornment:
              <AddIcon 
                unit='degree' 
                helptext={''}
                title=''
                imgSrc=''
              />,
          }}
          InputLabelProps={{
            style: { color: '#fff' },
            shrink: true,
          }}
          variant='standard'
          inputProps={{
            style: {
              color: 'white',
              textAlign: 'left'
            }, 
            min:-90, 
            max:90,
            step:0.1
          }}
        />
      </Grid>

      <Grid container spacing={1} alignItems='center' justifyContent='center'>
        <TextField
          id='filled-number'
          name='trans_x'
          label='Translation AP'
          type='number'
          defaultValue={finalDeviceFinalStep.trans_x}
          fullWidth
          onBlur={onChange}
          InputProps={{
            endAdornment:
              <AddIcon 
                unit='mm'
                helptext={''}
                title=''
                imgSrc=''
              />,
          }}
          InputLabelProps={{
            style: { color: '#fff' },
            shrink: true,
          }}
          variant='standard'
          inputProps={{
            style: {
              color: 'white',
              textAlign: 'left'
            }, 
            min:-90, 
            max:90,
            step:1
          }}
        />
      </Grid>

      <Grid container spacing={1} alignItems='center' justifyContent='center'>
        <TextField
          id='filled-number'
          name='trans_y'
          label='Translation ML'
          type='number'
          defaultValue={finalDeviceFinalStep.trans_y}
          fullWidth
          onBlur={onChange}
          InputProps={{
            endAdornment:
              <AddIcon 
                unit='mm'
                helptext={''}
                title=''
                imgSrc=''
              />,
          }}
          InputLabelProps={{
            style: { color: '#fff' },
            shrink: true,
          }}
          variant='standard'
          inputProps={{
            style: {
              color: 'white',
              textAlign: 'left'
            }, 
            min:-90, 
            max:90,
            step:1
          }}
        />
      </Grid>

      <Grid container direction='column' justifyContent ='flex-start' alignItems='center'>
        <Grid item xs={12} className={style.subcategory}>4 Holes setting</Grid>
      </Grid>
      
      <Grid container spacing={1} alignItems='center' justifyContent='center'>
        <TextField
          id='filled-number'
          name='max_height_4hole'
          label='Max height 4 holes'
          type='number'
          defaultValue={finalDeviceFinalStep.max_height_4hole}
          fullWidth
          onBlur={onChange}
          InputProps={{
            endAdornment:
              <AddIcon 
                unit='mm'
                helptext={''}
                title=''
                imgSrc=''
              />,
          }}
          InputLabelProps={{
            style: { color: '#fff' },
            shrink: true,
          }}
          variant='standard'
          inputProps={{
            style: {
              color: 'white',
              textAlign: 'left'
            }, 
            min:0, 
            max:500,
            step:1
          }}
        />
      </Grid>

      <Grid container spacing={1} alignItems='center' justifyContent='center'>
        <TextField
          id='filled-number'
          name='cull_index_of_4hole'
          label='Cull index of 4 holes'
          type='number'
          defaultValue={finalDeviceFinalStep.cull_index_of_4hole}
          fullWidth
          onBlur={onChange}
          InputProps={{
            endAdornment:
              <AddIcon 
                unit=''
                helptext={''}
                title=''
                imgSrc=''
              />,
          }}
          InputLabelProps={{
            style: { color: '#fff' },
            shrink: true,
          }}
          variant='standard'
          inputProps={{
            style: {
              color: 'white',
              textAlign: 'left'
            }, 
            min:-1, 
            max:3,
            step:1
          }}
        />
      </Grid>
      
      <Grid container spacing={1} alignItems='center' justifyContent='center'>
        <FormControl component="fieldset">
          <FormLabel component="legend">Bending apply</FormLabel>
          <RadioGroup aria-label="bending_holes" name="bending_holes" value={finalDeviceFinalStep.bending_holes} onChange={onChange} row >
            <FormControlLabel value={1} control={<GreyRadio/>} label="Yes"/>
            <FormControlLabel value={0} control={<GreyRadio/>} label="No"/>
          </RadioGroup>
        </FormControl>
      </Grid>

      <FormControl component="fieldset">
          <FormLabel component="legend">Choose Options</FormLabel>
          <FormGroup>
            <FormControlLabel
                control={<Checkbox checked={finalDeviceFinalStep.hexagon0} onChange={onChangeCheckboxs} name="hexagon0" />}
                label="Hole 0"
            />
            <FormControlLabel
                control={<Checkbox checked={finalDeviceFinalStep.hexagon1} onChange={onChangeCheckboxs} name="hexagon1" />}
                label="Hole 1"
            />
            <FormControlLabel
                control={<Checkbox checked={finalDeviceFinalStep.hexagon2} onChange={onChangeCheckboxs} name="hexagon2" />}
                label="Hole 2"
            />
            <FormControlLabel
                control={<Checkbox checked={finalDeviceFinalStep.hexagon3} onChange={onChangeCheckboxs} name="hexagon3" />}
                label="Hole 3"
            />
          </FormGroup>
      </FormControl>

      
      <Grid container direction='column' justifyContent ='flex-start' alignItems='center'>
        <Grid item xs={12} className={style.subcategory}>Other hole setting</Grid>
      </Grid>

      <Grid container spacing={1} alignItems='center' justifyContent='center'>
        <FormControl component="fieldset">
          <FormLabel component="legend">Center hole apply</FormLabel>
          <RadioGroup aria-label="center_hole_disable" name="center_hole_disable" value={finalDeviceFinalStep.center_hole_disable} onChange={onChange} row >
            <FormControlLabel value={0} control={<GreyRadio/>} label="Yes"/>
            <FormControlLabel value={1} control={<GreyRadio/>} label="No"/>
          </RadioGroup>
        </FormControl>
      </Grid>

      <Grid container spacing={1} alignItems='center' justifyContent='center'>
        <FormControl component="fieldset">
          <FormLabel component="legend">Bottom ring hole apply</FormLabel>
          <RadioGroup aria-label="outer_ring_hole" name="outer_ring_hole" value={finalDeviceFinalStep.outer_ring_hole} onChange={onChange} row >
            <FormControlLabel value={0} control={<GreyRadio/>} label="Yes"/>
            <FormControlLabel value={1} control={<GreyRadio/>} label="No"/>
          </RadioGroup>
        </FormControl>
      </Grid>

      <Grid container direction="row" spacing={1}>
        <Grid item xs={6}>
          <Button className={style.button} onClick={handleValueGeometry} size='small'>Apply</Button>
        </Grid>
        <Grid item xs={6}>
          <Button className={style.button} onClick={()=>handleExport(standardGeometry)} size='small'>Export</Button>
        </Grid>
      </Grid>
    </div>
  );
}
export default FormAlignFinalDeviceFinalStep;
